import { seoIntroContent } from '@/mocks/seoContent';

export default function FeatureComparison() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Feature Comparison At A Glance
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            See how Vigorbuy Spreadsheet stacks up against traditional spreadsheet solutions across key capabilities.
          </p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-700">Feature</th>
                <th className="text-left py-4 px-5 text-sm font-semibold text-primary-700">
                  <span className="flex items-center gap-2">
                    <i className="ri-check-double-line"></i>
                    Vigorbuy Spreadsheet
                  </span>
                </th>
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-500">
                  <span className="flex items-center gap-2">
                    <i className="ri-file-list-3-line"></i>
                    Traditional Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {seoIntroContent.comparisonRows.map((row, idx) => (
                <tr key={row.feature} className={`border-b border-background-200/40 ${idx % 2 === 0 ? 'bg-background-100/50' : ''}`}>
                  <td className="py-4 px-5 text-sm text-foreground-800 font-medium">{row.feature}</td>
                  <td className="py-4 px-5 text-sm text-primary-700 font-medium">{row.vigorbuy}</td>
                  <td className="py-4 px-5 text-sm text-foreground-500">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}